import { observable, computed } from 'mobx';
import { get } from '@utils/get';
import ListStore from '@stores/list';

export class SiteStore {
    @observable namespace = 'site';

    @observable siteConfig = null;
    @observable closeSiteConfig = null;
    @observable pluginConfig = null;
    @observable emojiList = [];
    @observable isEmojiLoading = false;
    @observable isLoading = false;
    @observable error = null;
    @observable appDownloadShowStatus = true; // h5 app下载入口是否显示
    @observable showHeader = true; // 是否显示header，默认显示
    @observable currentPhotographyWorkId = null; // 当前查看的摄影作品id，用于打开App深链接

    constructor() {
        this.lists = new ListStore();
    }

    @computed get isSiteClosed() {
        return !!this.closeSiteConfig;
    }

    @computed get siteName() {
        return get(this.siteConfig, 'setSite.siteName') || '';
    }

    @computed get siteIntroduction() {
        return get(this.siteConfig, 'setSite.siteIntroduction') || '';
    }

    // 当前访问的域名
    @computed get currentOrigin() {
        return window.location.origin || '';
    }

    // 后端 API 基础域名
    @computed get apiBase() {
        return this.currentOrigin;
    }

    @computed get hasEmoji() {
        return Array.isArray(this.emojiList) && this.emojiList.length > 0;
    }

    @computed get otherPermissions() {
        return {
            canInsertThreadAttachment: get(this.siteConfig, 'other.canInsertThreadAttachment', false),
            canInsertThreadImage: get(this.siteConfig, 'other.canInsertThreadImage', false),
            canInsertThreadVideo: get(this.siteConfig, 'other.canInsertThreadVideo', false),
            canInsertThreadVote: get(this.siteConfig, 'other.canInsertThreadVote', false),
            canInsertThreadGuess: get(this.siteConfig, 'other.canInsertThreadGuess', false),
            canInsertThreadGoods: get(this.siteConfig, 'other.canInsertThreadGoods', false),
            canInsertThreadForm: get(this.siteConfig, 'other.canInsertThreadForm', false),
            canInsertThreadRedPacket: get(this.siteConfig, 'other.canInsertThreadRedPacket', false),
            canInsertThreadReward: get(this.siteConfig, 'other.canInsertThreadReward', false),
            canInsertThreadAnonymous: get(this.siteConfig, 'other.canInsertThreadAnonymous', false),
            canInsertThreadPosition: get(this.siteConfig, 'other.canInsertThreadPosition', false),
            canInsertThreadPaid: get(this.siteConfig, 'other.canInsertThreadPaid', false),
            canInsertFixedAt: get(this.siteConfig, 'other.canInsertFixedAt', false),
        };
    }
}

const siteStore = new SiteStore();
export default siteStore;